<script>
	import { enhance } from '$app/forms';
	import { LogOut } from 'lucide-svelte';
</script>

<form method="POST" action="/?/logout" use:enhance>
	<button
		type="submit"
		class="py-1 text-primary flex gap-x-2 items-center [&>span]:hidden [&>span]:hover:block"
	>
		Logout
		<LogOut size={15} />
	</button>
</form>
